<template>
  <div>
    <followup-list ref="followupList" v-show="tabType === 'list'" @handleShow="handleShow" />
    <followup-visit v-if="tabType === 'visit'" :rowId="id" @handleShow="handleShow" />
    <followup-show v-if="tabType === 'show'" :rowId="id" @handleShow="handleShow" />
    <followup-activities v-if="tabType === 'activities'" :rowId="id" @handleShow="handleShow" />
    <followup-close-record v-if="tabType === 'closeRecord'" :rowId="id" @handleShow="handleShow" />
  </div>
</template>

<script>
// REQ-2026-601171 子账号核查数据看板（子账号回访）
// 沿用「子账号审核」页面同样的单路由+内部 tab 切换写法，避免为详情/填写/记录页各注册一条静态路由
import followupList from './list.vue'
import followupVisit from './visit.vue'
import followupShow from './show.vue'
import followupActivities from './activities.vue'
import followupCloseRecord from './closeRecord.vue'

export default {
  name: 'SubaccountFollowup',
  components: { followupList, followupVisit, followupShow, followupActivities, followupCloseRecord },
  data() {
    return {
      tabType: 'list',
      id: null
    }
  },
  methods: {
    handleShow(id, type) {
      this.tabType = type || 'list'
      this.id = id
      if (this.tabType === 'list') {
        this.refreshList()
      }
    },
    // 编辑/审核完返回列表时主动重拉。
    // 这些容器是"单路由 + 内部 tab"写法：列表用 v-show、子页用 v-if，
    // 列表组件**从头到尾不销毁**，返回时既不重建也不重新请求，所以行数据和汇总卡片都是旧的。
    // 不改成 v-if 是因为那会连筛选条件和页码一起丢掉，返回就跳回第 1 页。
    // doQueryList({}) 不传 pageNo/pageSize —— 组件内是 `if (pageNo)` 才覆盖，
    // 所以当前页码和筛选条件都保留，只是重新拉一次。
    refreshList() {
      this.$nextTick(() => {
        const list = this.$refs.followupList
        if (list && list.doQueryList) {
          // 汇总卡片和列表是同一个响应（data.metrics），一次调用两个都刷新
          list.doQueryList({})
        }
      })
    }
  }
}
</script>
